import PropTypes from "prop-types";
import ExploreBenefits from "../explore-benefits";
import styles from "./styles";
import global from "../../styles";
import JoinNow from "../join-now";
import TsAndCs from "../tsAndCs";
import classNames from "classnames";
import Decoration from "../decoration";
import { formatHeaderWords } from "../../helpers/formatHeaderWords";
import { useLocaleProvider, useTranslate } from "../../context/locale-provider";

const WorldOfStyle = ({ currentTierId, assetsUrl, isAnonymous }) => {
  const translate = useTranslate(useLocaleProvider());
  const header = translate("loyalty_landing_page_summary_header");
  const headerFormatted = formatHeaderWords(header);
  return (
    <div className={styles.wosImageContainer}>
      <picture className={styles.wosImage}>
        <source
          srcSet={`${assetsUrl}/dWeb-WorldofStyle_SS25_j996pk`}
          media="(min-width: 480px)"
          width="100%"
        />
        <img
          src={`${assetsUrl}/mWeb-WorldofStyle_SS25_vdoyv0`}
          alt="connect"
          width="100%"
          loading="lazy"
        />
      </picture>
      <div>
        <div className={classNames(styles.woscontainer, global.leftAlignment)}>
          <Decoration
            width="185"
            height="36"
            className={global.desktopAndTablet}
            x="48"
            y="0"
          />
          <Decoration
            width="60"
            height="288"
            className={global.desktopAndTablet}
            x="0"
            y="0"
          />
          <Decoration
            width="32"
            height="294"
            className={global.mobileOnly}
            x="0"
            y="0"
          />
          <div className={classNames(styles.header, global.headerASOSWorld)}>
            <h2 className={global.textBackground} aria-label={header}>
              {headerFormatted}
            </h2>
          </div>
          <Decoration
            width="84"
            height="36"
            className={global.desktopAndTablet}
          />
          <Decoration
            width="37"
            height="36"
            className={global.mobileOnly}
            x="0"
            y="-2"
          />
          <div
            className={classNames(
              global.leavesden1,
              styles.description,
              global.textBackground
            )}
          >
            {translate("loyalty_landing_page_summary_body")}
          </div>
          <Decoration
            width="457"
            height="72"
            className={global.desktopAndTablet}
            x="0"
            y="-120"
          />
          <div
            className={classNames(
              styles.buttonLinksContainer,
              global.desktopAndTablet,
              global.textBackground
            )}
          >
            <span className={global.desktopAndTablet}>
              {currentTierId ? (
                <ExploreBenefits
                  optedInButtonText={translate(
                    "loyalty_landing_page_summary_opted_in_button"
                  )}
                />
              ) : (
                <JoinNow
                  isAnonymous={isAnonymous}
                  optedOutButtonText={translate(
                    "loyalty_landing_page_summary_opted_out_button"
                  )}
                />
              )}
            </span>
            <span
              className={classNames(global.desktopAndTablet, styles.tsAndCs)}
            >
              <TsAndCs
                termsText={translate(
                  "loyalty_landing_page_summary_terms_link_copy_web"
                )}
                privacyPolicyText={translate(
                  "loyalty_landing_page_summary_privacy_link_copy_web"
                )}
              />
            </span>
          </div>
          <Decoration
            width="185"
            height="36"
            className={global.desktopAndTablet}
            x="223"
            y="0"
          />
        </div>
      </div>
    </div>
  );
};

WorldOfStyle.propTypes = {
  currentTierId: PropTypes.string,
  assetsUrl: PropTypes.string.isRequired,
  isAnonymous: PropTypes.bool,
};

WorldOfStyle.defaultProps = {
  currentTierId: "",
  isAnonymous: true,
};

export default WorldOfStyle;
